import { TimeUtils } from '../utils/TimeUtils.ts';
import { HTTPStatus } from './ErrorEnums.ts';
import { ErrorDefault } from './Errors.ts';
(function(ErrorsRanked) {
    class NoAdBlockState extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.waitingForAdblockState'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.NoAdBlockState = NoAdBlockState;
    class InvalidSeason extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.invalidSeason'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.InvalidSeason = InvalidSeason;
    class BetaSeasonsNotSaved extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.betaSeason'
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.BetaSeasonsNotSaved = BetaSeasonsNotSaved;
    class NoAccessToCitiesAndKnights extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.noAccessToCitiesAndKnights'
            };
            const httpStatus = HTTPStatus.Unauthorized;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.NoAccessToCitiesAndKnights = NoAccessToCitiesAndKnights;
    class NoActiveSeason extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.noActiveSeason'
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.NoActiveSeason = NoActiveSeason;
    class NoNewSeasonAnnounced extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.noSeasonAnnounced'
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.NoNewSeasonAnnounced = NoNewSeasonAnnounced;
    class NextSeasonNotStarted extends ErrorDefault {
        constructor(nextSeasonStart){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.nextSeasonNotStarted',
                options: {
                    timeUntilNextSeason: `${TimeUtils.getDaysHoursMinutesBetweenDatesString(nextSeasonStart, new Date())}`
                }
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsRanked.NextSeasonNotStarted = NextSeasonNotStarted;
    class MustLogin extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.rankedError.title'
            };
            const message = {
                key: 'strings:popups.errors.rankedError.logInForRanked'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    // Ideally we should replace this error with `ErrorsMustLogin.Generic()` but for socket msgs we still need this error for now.
    ErrorsRanked.MustLogin = MustLogin;
})(ErrorsRanked || (ErrorsRanked = {}));
export var ErrorsRanked;
